import { render } from "./ProductSlider.vue?vue&type=template&id=4ada9412"
import script from "./ProductSlider.vue?vue&type=script&lang=js"
export * from "./ProductSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__